
import React, { useEffect, useState, Component } from "react";
import { applyDataTable } from '../../custom/dataTable';
import ListItem from '@material-ui/core/ListItem';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { useSelector, useDispatch } from 'react-redux';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Multiselect from "multiselect-react-dropdown"
import Vector from '@material-ui/icons/Close';
import downloadIcon from '../../../Assets/img/svg/DownloadIcon.svg';
import shareIcon from '../../../Assets/img/svg/ShareIcon.svg';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import $ from 'jquery';
import del from "../../../Assets/img/svg/Del.svg"
import moment from "moment";
import Divider from '@material-ui/core/Divider';
import { useNavigate } from "react-router-dom"
import {
    TextField, FormControlLabel, Radio, Checkbox,
    Select, MenuItem, InputBase, Chip, Input, Button, InputAdornment,
    IconButton, FormHelperText, FormControl, RadioGroup
} from '@material-ui/core';
import PropTypes from 'prop-types';
import styles from "../../../Assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import axios from "axios";
import API from "../../../helpers/endpointService"
import { Buffer } from 'buffer';
// import { Grid } from "ag-grid-community";
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { inspectionSystem } from "../../Constants";
import {warningAlert,successAlert} from "../../custom/alert"

const useStyles = makeStyles((theme) => ({
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
        padding: "5px 10px"
    },
    fontIcon: {
        paddingRight: "8px",
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    error: {
        color: '#f44336',
    },
    helperText: {
        '& p': {
            marginLeft: "0px !important"
        }
    },
}));
const BootstrapInput = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);


const names = [
    'Oliver Hansen',
    'Van Henry',
    'April Tucker',
    'Ralph Hubbard',
];

function getStyles(name, personName, theme) {
    return {
        fontWeight:
            personName.indexOf(name) === -1
                ? theme.typography.fontWeightRegular
                : theme.typography.fontWeightMedium,
    };
}
const BootstrapError = withStyles((theme) => ({
    root: {
        'label + &': {
            marginTop: theme.spacing(3),
        },
    },
    input: {
        borderRadius: 0,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #f44336',
        fontSize: 16,
        padding: '10px 26px 10px 12px',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
    },
}))(InputBase);
class FinalReport extends Component {
    constructor(props) {
        super(props);
        this.multiselectRef = React.createRef();
        this.state = {
            isMobile: false,
            isError: false,
            report: "",
            ProjectId: 0,
            ShipId: 0,
            less: false,
            shiptype: 0,
            InspectionId: 0,
            values: [],
            HTMLreport:"",
            Status: "",
            addData: {
                "Id": 0,
                "UniqueId": ""
            }
        }
    }
    componentDidMount() {
        this.state.ShipId = parseInt(localStorage.getItem("DashId"));
        this.state.addData.Id = parseInt(localStorage.getItem("DashId"));
        this.state.InspectionId = parseInt(localStorage.getItem("InspectionId"));
        this.setState({})
        this.getfinalreport(this.state.ShipId, this.state.InspectionId);
        if (parseInt(localStorage.getItem("DashId")) != null) {
            this.getshipinfo(localStorage.getItem("DashId"))
            this.getshipbasicinfo(localStorage.getItem("DashId"))
        }
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }

    getshipbasicinfo = (data) => {
        let apiUrl = API.GET_SHIP + "/id?id=" + data;
        axios({
            method: "get",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.Status = response.data?.Status;
                    this.setState({})
                    // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                } else {
                    // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            });

    };

    getshipinfo = (data) => {
        const { dispatch } = this.props;
        let Inspection = parseInt(localStorage.getItem("InspectionId"))
        let Id = parseInt(data)
        let apiUrl = `${API.Get_Vessel}?ShipId=${Id}&InspectionId=${Inspection}&SectionId=${inspectionSystem.Vesselparticulars}`;
        this.props.dispatch({ type: "SHOW_LOADER", data: true });
        axios.get(apiUrl)
            .then((response) => {
                if (response?.status === 200) {
                    if (response?.data.Id !== 0) {
                        this.state.shiptype = parseInt(response?.data.ShipType);
                        this.setState({})
                    }
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                }
            });
    };

    setLess = () => {
        this.state.less = !this.state.less;
        this.setState({});
    }

    getfinalreport = (ship, inspection) => {
        let apiUrl = API.FINAL_REPORTSHOW + '?shipId=' + ship + '&inspectionId=' + inspection;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "GET",
            url: apiUrl,
        })
            // .then((response) => {
            //     if (response?.status === 200) {
            //         this.state.addData.UniqueId = response?.data.UniqueId
            //         this.state.HTMLreport=response?.data?.SourceHtml
            //         this.setState({})
            //         this.toBase64(response?.data?.SourceHtml);
            //         console.log("html",response?.data?.SourceHtml)
            //     }
            //     else {
            //         this.props.dispatch({ type: "SHOW_LOADER", data: false })
            //     }
            // })
            .then((response) => {
                if (response?.status === 200) {
                    // debugger;
                    this.state.addData.UniqueId = response?.data.UniqueId;
                    this.state.HTMLreport = response?.data?.SourceHtml;
                    this.setState({});
                    this.toBase64(response?.data?.SourceHtml);
                    console.log("html", response?.data?.SourceHtml);
                    
                    const tempElement = document.createElement("div");
                    tempElement.innerHTML = this.state.HTMLreport;
            
                     
                    const decarbanizationSummaryElement = tempElement.querySelector("#SectionDecarbanizationSummary");
            
                    if (decarbanizationSummaryElement) {
                        const computedStyle = window.getComputedStyle(decarbanizationSummaryElement);
                        if (decarbanizationSummaryElement.style.display === "none") {                       
                        const decarbanization1 = document.getElementById("Decarbanization1");
                        const parentDiv = decarbanization1.parentElement;
                        decarbanization1.style.display = "none";         
                        parentDiv.style.display = "none";
                        }
                        else
                        {
                            document.getElementById("Decarbanization1").style.display = "block";
                        }
                    }              
                    
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false });
                }
            })
            
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };

    toBase64(data) {
        let buff = Buffer.from(data);
        let stringToBase64 = buff.toString('base64');
        this.state.report = stringToBase64;
        this.setState({}, () => {
            this.syncAheadGradeNavVisibility();
            this.props.dispatch({ type: "SHOW_LOADER", data: false })
            console.log("iframe","data:text/html;base64," + this.state.report)
        })
    }

    syncAheadGradeNavVisibility = () => {
        const isGradeApplicable = localStorage.getItem("IsGradeApplicable") === "true" || localStorage.getItem("IsGradeApplicable") === true;
        const aheadGradeNav = document.getElementById("AheadGrade1");
        if (aheadGradeNav && !isGradeApplicable) {
            aheadGradeNav.style.display = "none";
            return;
        }
        const html = this.state.HTMLreport;
        if (!html) {
            return;
        }

        const tempElement = document.createElement("div");
        tempElement.innerHTML = html;
        const aheadGradeSection = tempElement.querySelector("#SectionAheadGrade");

        if (!aheadGradeNav || !aheadGradeSection) {
            return;
        }

        const sectionStyle = (aheadGradeSection.getAttribute("style") || "").replace(/\s/g, "").toLowerCase();
        aheadGradeNav.style.display = sectionStyle.includes("display:none") ? "none" : "";
    };
    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
        $("#FINAL1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#FinalReport1 .MuiListItemText-primary").addClass("fw-bolder")
        $("#FinalReport").removeClass("d-none")
        $("#FinalReport").addClass("d-block")
        $("#FR .MuiListItemText-primary").addClass("fw-bolder")
        $("#FRL").addClass("active-color")
    };

    DownloadReport = () => {
        if (this.state.addData.Id != 0) {
            this.DownloadFinalReport(this.state.addData)
        }
    }

    onSelectVaues = (e, node) => {
        if (node == "onremove" || node == "onselect") {
            this.state.addData.Email = e;
            this.state.addData.StartDate = moment(new Date()).format("YYYY-MM-DD");
            this.state.addData.EndDate = moment(new Date()).format("YYYY-MM-DD");
            this.state.addData.ShareByEmail = true;
            this.setState({})
        }
        if (node == "onsearch") {
        }
    }

    DownloadFinalReport = (data) => {
        let apiUrl = API.FINAL_REPORT_DOWN;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
            responseType: "blob", })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    let fileName = response.headers['content-disposition'].split('filename="')[1].split('";')[0];
                    let blob = new Blob([response.data]);
                    let url = URL.createObjectURL(blob);
                    let a = document.createElement('a');
                    a.href = url;
                    a.download = fileName;
                    a.click();
                    successAlert("Downloaded successfully.");
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
            });
    };

    getmail = (data) => {
        let apiUrl = API.PRECUTTING_GETMAIL + '?projectId=' + data;
        axios({
            method: "get",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    if (response?.data.length > 0) {
                        this.state.values = response?.data;
                        this.setState({})
                    }
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    sendmail = () => {
        if (this.state.addData.Email.length != 0) {
            this.sendmailreport(this.state.addData)
        }

    }
    Cancel = () => {
        this.multiselectRef.current.resetSelectedValues();
    }
    DeleteItem = () => {
        window.$("#deletepopup").modal("hide");
    }
    sendmailreport = (data) => {
        let apiUrl = API.FINAL_REPORT_DOWN
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (response?.status === 200) {
                    this.multiselectRef.current.resetSelectedValues();
                } else {
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                }
                if (error?.response?.status === 400) {
                    window.$("#deletepopup").modal("show");
                }
            });
    };

    componentWillUnmount() {
        clearInterval(this.interval);
        $("#FINAL1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#FinalReport1 .MuiListItemText-primary").removeClass("fw-bolder")
        $("#FinalReport").addClass("d-none")
        $("#FinalReport").removeClass("d-block")
        $("#FR .MuiListItemText-primary").removeClass("fw-bolder")
        $("#FRL").removeClass("active-color")
    }
    sidebar = () => {
        this.props.navigate("/sidebarreport");
    }

    navigatehead = (dataid, str) => {
        var iframe= document.getElementById("myFrame");
        var src = iframe.srcdoc;
        if(src.includes(dataid)){
          var elmnt = iframe.contentWindow.document.getElementById(dataid);
            elmnt.style.height =  elmnt.scrollHeight + "px";
            elmnt.scrollIntoView(true);
            $(".naviIcon").removeClass("d-block");
            $(".naviIcon").addClass("d-none");
            $("#" + str).removeClass("d-none");
            $("#" + str).addClass("d-block");
            $(".textNaviIcon .MuiListItemText-primary").removeClass("fw-bolder");
            $("#" + str + "1 .MuiListItemText-primary").addClass("fw-bolder");
        }
      /*   var iframe = document.getElementById("myFrame");
        var src = iframe.src;
        if (src.indexOf('#') >= 0) src = src.substr(0, src.indexOf("#"));
        iframe.src = src + "#" + dataid; */
        
    }

    AddCancel1 = () => {
        this.props.navigate(`/shiplist`)
    }

    render() {
        const { isMobile, shiptype, less } = this.state;
        let { classes, menuToggle } = this.props;
        return (
            <>
                {isMobile ?
                    <>
                        <div className="row w-100  mt-4 mob-topfixed">
                            <div className="col-5 w-50 mt-auto">
                                <List className="pt-4 mt-4 " style={{ backgroundColor: "#F6F6F6" }}>
                                    <ListItem onClick={this.sidebar} >
                                        <ListItemText id={"FINAL" + "1"} className=' textNaviIcon' primary="Reports" />
                                        <NavigateNextIcon id="FINAL" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                        <Divider className='border-bottom' />
                                    </ListItem>
                                </List>
                            </div>
                            <div className="col-7 pt-3 mt-5 w-50">
                                <h4>Final Report</h4>
                            </div>
                        </div>
                    </>
                    :
                    <></>
                }
                <div className="pt-2 ml-auto scroll-hide mt-138" style={{ backgroundColor: "#FFFFFF", width: "100%", marginTop: this.state.isMobile ? 8 : -85 }}>
                    {((this.state.report != "" && localStorage.getItem("UserRoles") == "Admin" && (this.state.Status == "Reviewed and Approved" || this.state.Status == "Inspection Completed")) || (this.state.report != "" && localStorage.getItem("UserRoles") == "Client" && this.state.Status == "Reviewed and Approved")||(this.state.report != "" && localStorage.getItem("UserRoles") == "External Client" && this.state.Status == "Reviewed and Approved")) ?
                        <>
                            <div className="input-group">
                                {/* <div className="col-1"> */}
                                <div style={{ width: "240px" }}>
                                    <List className='scroll-hidden' style={{ overflowY: 'auto', width: localStorage.getItem("UserRoles").toLowerCase() == "client"?300:240, height: "calc(100vh - 64px)", backgroundColor: "#F6F6F6" }}>
                                    <ListItem button onClick={() => this.navigatehead("SectionInspection", "Inspection")} >
                                            <ListItemText id={"Inspection" + "1"} className='pl-3 textNaviIcon' primary="Inspection Summary" />
                                            <NavigateNextIcon id="Inspection" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                            <Divider />
                                        </ListItem>
                                        {(localStorage.getItem("IsGradeApplicable") === "true" || localStorage.getItem("IsGradeApplicable") === true) && (
                                            <ListItem id="AheadGrade1" button onClick={() => this.navigatehead("SectionAheadGrade", "AheadGrade")} >
                                                <ListItemText id={"AheadGrade" + "1"} className='pl-3 textNaviIcon' primary="Ahead Grade" />
                                                <NavigateNextIcon id="AheadGrade" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                <Divider />
                                            </ListItem>
                                        )}
                                        <ListItem button onClick={() => this.navigatehead("SectionKeyNotableItems", "KeyNotable")} >
                                            <ListItemText id={"KeyNotable" + "1"} className='pl-3 textNaviIcon' primary="Key Notable Items" />
                                            <NavigateNextIcon id="KeyNotable" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                            <Divider />
                                        </ListItem>
                                        <ListItem button onClick={() => this.navigatehead("SectionGradingData", "Grading")} >
                                            <ListItemText id={"Grading" + "1"} className='pl-3 textNaviIcon' primary="Grading Data" />
                                            <NavigateNextIcon id="Grading" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                            <Divider />
                                        </ListItem>
                                        <ListItem button onClick={() => this.navigatehead("SectionDesignConstruction", "Design")} >
                                            <ListItemText id={"Design" + "1"} className='pl-3 textNaviIcon' primary="Design & Construction" />
                                            <NavigateNextIcon id="Design" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                            <Divider />
                                        </ListItem>
                                        <ListItem button onClick={() => this.navigatehead("SectionHull", "Hull")} >
                                            <ListItemText id={"Hull" + "1"} className='pl-3 textNaviIcon' primary="Hull" />
                                            <NavigateNextIcon id="Hull" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                            <Divider />
                                        </ListItem>
                                        <ListItem button onClick={() => this.navigatehead("SectionPoopDeck", "PoopDeck")} >
                                            <ListItemText id={"PoopDeck" + "1"} className='pl-3 textNaviIcon' primary="Foc’scle & Poop Deck" />
                                            <NavigateNextIcon id="PoopDeck" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                            <Divider />
                                        </ListItem>
                                        <ListItem button onClick={() => this.navigatehead("SectionMainDeck", "MainDeck")} >
                                            <ListItemText id={"MainDeck" + "1"} className='pl-3 textNaviIcon' primary="Main Deck & Fittings" />
                                            <NavigateNextIcon id="MainDeck" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                            <Divider />
                                        </ListItem>
                                        <ListItem button onClick={() => this.navigatehead("SectionBallast", "Ballast")} >
                                            <ListItemText id={"Ballast" + "1"} className='pl-3 textNaviIcon' primary="Ballast Tanks & Void Spaces" />
                                            <NavigateNextIcon id="Ballast" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                            <Divider />
                                        </ListItem>
                                        <ListItem button onClick={() => this.navigatehead("SectionGalley", "Galley")} >
                                            <ListItemText id={"Galley" + "1"} className='pl-3 textNaviIcon' primary="Galley & Accomodation" />
                                            <NavigateNextIcon id="Galley" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                            <Divider />
                                        </ListItem>
                                        <ListItem button onClick={() => this.navigatehead("SectionNavigation", "NavigationBridge")} >
                                            <ListItemText id={"NavigationBridge" + "1"} className='pl-3 textNaviIcon' primary="Navigation Bridge and Communication" />
                                            <NavigateNextIcon id="NavigationBridge" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                            <Divider />
                                        </ListItem>
                                        <ListItem button onClick={() => this.navigatehead("SectionEngineRoom", "EngineRoom")} >
                                            <ListItemText id={"EngineRoom" + "1"} className='pl-3 textNaviIcon' primary="Engine Room, Machinery & Machinery Spaces" />
                                            <NavigateNextIcon id="EngineRoom" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                            <Divider />
                                        </ListItem>
                                        <ListItem button onClick={() => this.navigatehead("SectionFireSafety", "FireSafety")} >
                                            <ListItemText id={"FireSafety" + "1"} className='pl-3 textNaviIcon' primary="Fire Fighting Appliances" />
                                            <NavigateNextIcon id="FireSafety" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                            <Divider />
                                        </ListItem>
                                        <ListItem button onClick={() => this.navigatehead("SectionLifeSaving", "LifeSaving")} >
                                            <ListItemText id={"LifeSaving" + "1"} className='pl-3 textNaviIcon' primary="Life Saving Equipment" />
                                            <NavigateNextIcon id="LifeSaving" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                            <Divider />
                                        </ListItem>
                                        <ListItem button onClick={() => this.navigatehead("SectionSafeWorking", "SafeWorking")} >
                                            <ListItemText id={"SafeWorking" + "1"} className='pl-3 textNaviIcon' primary="Safe Working" />
                                            <NavigateNextIcon id="SafeWorking" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                            <Divider />
                                        </ListItem>
                                        <ListItem button onClick={() => this.navigatehead("SectionPollution", "Pollution")} >
                                            <ListItemText id={"Pollution" + "1"} className='pl-3 textNaviIcon' primary="Pollution Control" />
                                            <NavigateNextIcon id="Pollution" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                            <Divider />
                                        </ListItem>
                                        <ListItem button onClick={() => this.navigatehead("SectionOnBoard", "OnboardManagement")} >
                                            <ListItemText id={"OnboardManagement" + "1"} className='pl-3 textNaviIcon' primary="Onboard Management and Crew Welfare" />
                                            <NavigateNextIcon id="OnboardManagement" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                            <Divider />
                                        </ListItem>
                                        <ListItem button onClick={() => this.setLess()} >
                                            <ListItemText className='pl-3' primary="Cargo Systems" />
                                            <NavigateNextIcon className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                            {less ? <ExpandMore /> : <ExpandLess />}
                                            <Divider />
                                        </ListItem>
                                        {less ? "" : <>
                                            <ListItem onClick={() => this.navigatehead("SectionCargoSystems", "CargoSystems")} button>
                                                <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >&nbsp;I&nbsp;</Typography>
                                                <ListItemText id={"CargoSystems" + "1"} className='pl-3 textNaviIcon' primary="Cargo Systems Summary" />
                                                <NavigateNextIcon id="CargoSystems" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                <Divider />
                                            </ListItem>
                                            {shiptype === 9 ?
                                                <>
                                                    <ListItem button onClick={() => this.navigatehead("SectionCargoCondition", "Cargocon")} >
                                                        <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  II&nbsp;</Typography>
                                                        <ListItemText id={"Cargocon" + "1"} className='pl-3 textNaviIcon' primary="Cargo Condition" />
                                                        <NavigateNextIcon id="Cargocon" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                        <Divider />
                                                    </ListItem>
                                                    <ListItem button onClick={() => this.navigatehead("SectionCargoSystems2", "Cargosys")} >
                                                        <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  III&nbsp;</Typography>
                                                        <ListItemText id={"Cargosys" + "1"} className='pl-3 textNaviIcon' primary="Cargo Systems" />
                                                        <NavigateNextIcon id="Cargosys" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                        <Divider />
                                                    </ListItem>
                                                    <ListItem button onClick={() => this.navigatehead("SectionLifting", "Lifting")} >
                                                        <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  IV&nbsp;</Typography>
                                                        <ListItemText id={"Lifting" + "1"} className='pl-3 textNaviIcon' primary="Lifting Appliances" />
                                                        <NavigateNextIcon id="Lifting" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                        <Divider />
                                                    </ListItem>
                                                    <ListItem button onClick={() => this.navigatehead("SectionClosing", "Closing")} >
                                                        <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  V&nbsp;</Typography>
                                                        <ListItemText id={"Closing" + "1"} className='pl-3 textNaviIcon' primary="Closing Appliances" />
                                                        <NavigateNextIcon id="Closing" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                        <Divider />
                                                    </ListItem>
                                                    <ListItem button onClick={() => this.navigatehead("SectionSecuring", "Securing")} >
                                                        <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  VI&nbsp;</Typography>
                                                        <ListItemText id={"Securing" + "1"} className='pl-3 textNaviIcon' primary="Cargo Securing" />
                                                        <NavigateNextIcon id="Securing" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                        <Divider />
                                                    </ListItem>
                                                </> : shiptype === 10 ?
                                                    <>
                                                        <ListItem button onClick={() => this.navigatehead("SectionCargoBulker", "bulkerCargocon")} >
                                                            <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  II&nbsp;</Typography>
                                                            <ListItemText id={"bulkerCargocon" + "1"} className='pl-3 textNaviIcon' primary="CargoSystem Bulker" />
                                                            <NavigateNextIcon id="bulkerCargocon" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                            <Divider />
                                                        </ListItem>
                                                        <ListItem button onClick={() => this.navigatehead("SectionHatchCovers", "bulkerCargosys")} >
                                                            <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  III&nbsp;</Typography>
                                                            <ListItemText id={"bulkerCargosys" + "1"} className='pl-3 textNaviIcon' primary="Hatch Covers Condition" />
                                                            <NavigateNextIcon id="bulkerCargosys" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                            <Divider />
                                                        </ListItem>
                                                        <ListItem button onClick={() => this.navigatehead("SectionHatchCoamings", "bulkerLifting")} >
                                                            <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  IV&nbsp;</Typography>
                                                            <ListItemText id={"bulkerLifting" + "1"} className='pl-3 textNaviIcon' primary="Hatch Coamings Condition" />
                                                            <NavigateNextIcon id="bulkerLifting" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                            <Divider />
                                                        </ListItem>
                                                        <ListItem button onClick={() => this.navigatehead("SectionDocumentationAdditional", "bulkerClosing")} >
                                                            <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  V&nbsp;</Typography>
                                                            <ListItemText id={"bulkerClosing" + "1"} className='pl-3 textNaviIcon' primary="Documentation and Additional Features" />
                                                            <NavigateNextIcon id="bulkerClosing" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                            <Divider />
                                                        </ListItem>
                                                        <ListItem button onClick={() => this.navigatehead("SectionCargoLifting", "bulkerSecuring")} >
                                                            <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  VI&nbsp;</Typography>
                                                            <ListItemText id={"bulkerSecuring" + "1"} className='pl-3 textNaviIcon' primary="Cargo Lifting Appliances" />
                                                            <NavigateNextIcon id="bulkerSecuring" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                            <Divider />
                                                        </ListItem>
                                                    </> :shiptype === 70 ?
                                                <>
                                                 <ListItem button onClick={() => this.navigatehead("SectionCargoTanksLNG", "CargotankLNG")} >
                                                        <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  II&nbsp;</Typography>
                                                        <ListItemText id={"CargotankLNG" + "1"} className='pl-3 textNaviIcon' primary="Cargo Tanks" />
                                                        <NavigateNextIcon id="CargtankLNG" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                        <Divider />
                                                    </ListItem>
                                                    <ListItem button onClick={() => this.navigatehead("SectionPumpingandPipingLNG", "PipingsysLNG")} >
                                                        <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  III&nbsp;</Typography>
                                                        <ListItemText id={"PipingsysLNG" + "1"} className='pl-3 textNaviIcon' primary="Pumping/Piping Systems" />
                                                        <NavigateNextIcon id="PipingsysLNG" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                        <Divider />
                                                    </ListItem>
                                                    <ListItem button onClick={() => this.navigatehead("SectionMonitoringLNG", "MonitoringLNG")} >
                                                        <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  IV&nbsp;</Typography>
                                                        <ListItemText id={"MonitoringLNG" + "1"} className='pl-3 textNaviIcon' primary="Monitoring/Safety Arrangements" />
                                                        <NavigateNextIcon id="MonitoringLNG" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                        <Divider />
                                                    </ListItem>
                                                    <ListItem button onClick={() => this.navigatehead("SectionVettingLNG", "EquipmentLNG")} >
                                                        <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  V&nbsp;</Typography>
                                                        <ListItemText id={"EquipmentLNG" + "1"} className='pl-3 textNaviIcon' primary="Equipment" />
                                                        <NavigateNextIcon id="EquipmentLNG" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                        <Divider />
                                                    </ListItem>
                                                 </>:shiptype === 71 ?<>
                                                 <ListItem button onClick={() => this.navigatehead("SectionCargoTanksLPG", "CargotankLPG")} >
                                                       <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  II&nbsp;</Typography>
                                                       <ListItemText id={"CargotankLPG" + "1"} className='pl-3 textNaviIcon' primary="Cargo Tanks" />
                                                       <NavigateNextIcon id="CargtankLPG" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                       <Divider />
                                                   </ListItem>
                                                   <ListItem button onClick={() => this.navigatehead("SectionPumpingandPipingLPG", "PipingsysLPG")}>
                                                       <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  III&nbsp;</Typography>
                                                       <ListItemText id={"PipingsysLPG" + "1"} className='pl-3 textNaviIcon' primary="Pumping/Piping Systems" />
                                                       <NavigateNextIcon id="PipingsysLPG" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                       <Divider />
                                                   </ListItem>
                                                   <ListItem button onClick={() => this.navigatehead("SectionMonitoringLPG", "MonitoringLPG")}>
                                                       <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  IV&nbsp;</Typography>
                                                       <ListItemText id={"MonitoringLPG" + "1"} className='pl-3 textNaviIcon' primary="Monitoring/Safety Arrangements" />
                                                       <NavigateNextIcon id="MonitoringLPG" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                       <Divider />
                                                   </ListItem>
                                                  <ListItem button onClick={() => this.navigatehead("SectionVettingLPG", "EquipmentLPG")}>
                                                       <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  V&nbsp;</Typography>
                                                       <ListItemText id={"EquipmentLPG" + "1"} className='pl-3 textNaviIcon' primary="Equipment" />
                                                       <NavigateNextIcon id="EquipmentLPG" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                       <Divider />
                                                   </ListItem>
                                                 </>:<>
                                                        <ListItem button onClick={() => this.navigatehead("SectionCargoTanks", "Cargotank")} >
                                                            <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  II&nbsp;</Typography>
                                                            <ListItemText id={"Cargotank" + "1"} className='pl-3 textNaviIcon' primary="Cargo Tanks" />
                                                            <NavigateNextIcon id="Cargotank" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                            <Divider />
                                                        </ListItem>
                                                        <ListItem button onClick={() => this.navigatehead("SectionPumpingandPiping", "Pipingsys")} >
                                                            <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  III&nbsp;</Typography>
                                                            <ListItemText id={"Pipingsys" + "1"} className='pl-3 textNaviIcon' primary="Pumping/Piping Systems" />
                                                            <NavigateNextIcon id="Pipingsys" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                            <Divider />
                                                        </ListItem>
                                                        <ListItem button onClick={() => this.navigatehead("SectionMonitoring", "Monitoring")} >
                                                            <Typography className={classes.leftCount} style={{ marginLeft: "30px" }} >  IV&nbsp;</Typography>
                                                            <ListItemText id={"Monitoring" + "1"} className='pl-3 textNaviIcon' primary="Monitoring/Safety Arrangements" />
                                                            <NavigateNextIcon id="Monitoring" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                                            <Divider />
                                                        </ListItem>
                                                    </>}
                                        </>}
                                        <ListItem button onClick={() => this.navigatehead("SectionDecarbanizationSummary", "Decarbanization")} >
                                            <ListItemText id={"Decarbanization" + "1"} className='pl-3 textNaviIcon' primary="Decarbanization Summary" />
                                            <NavigateNextIcon id="Decarbanization" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                            <Divider />
                                        </ListItem>
                                        <ListItem button onClick={() => this.navigatehead("SectionConcluding", "Concluding")} >
                                            <ListItemText id={"Concluding" + "1"} className='pl-3 textNaviIcon' primary="Concluding Statement" />
                                            <NavigateNextIcon id="Concluding" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                            <Divider />
                                        </ListItem>
                                        <ListItem button onClick={() => this.navigatehead("SectionNotesReader", "NotesReader")} >
                                            <ListItemText id={"NotesReader" + "1"} className='pl-3 textNaviIcon' primary="Notes To The Reader" />
                                            <NavigateNextIcon id="NotesReader" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                            <Divider />
                                        </ListItem>
                                    </List>
                                </div>
                                {/* </div> */}
                                {/* <div className="col-12"> */}
                                <div className="ml-auto scroll-hide mt-138" style={{ width:localStorage.getItem("UserRoles").toLowerCase() == "client"?"calc(100% - 300px)": "calc(100% - 240px)", height: "calc(100vh - 64px)", overflowY: "hidden" }}>
                                    {isMobile ?
                                        <table className="dataTable border-top" width="100%" >
                                            <tbody>
                                                <tr className="">
                                                    <td width="5%" className="border-right text-center">
                                                        <i
                                                            class="fa fa-arrow-left cursorPointer"
                                                            onClick={this.AddCancel1}
                                                        ></i>
                                                    </td>
                                                    <td className="border-right text-center">
                                                        <img className="cursorPointer" src={downloadIcon} onClick={() => this.DownloadReport()} style={{ marginTop: '-4px' }}></img>
                                                        <span className="p-2 cursorPointer" onClick={() => this.DownloadReport()}>Download</span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        : <>
                                            <table className="dataTable">
                                                <tbody>
                                                    <tr className="">
                                                        <td width="5%" className="border-right text-center">
                                                            <i
                                                                class="fa fa-arrow-left cursorPointer"
                                                                onClick={this.AddCancel1}
                                                            ></i>
                                                        </td>
                                                        <td className="">
                                                            <img className="pl-2 cursorPointer" src={downloadIcon} onClick={() => this.DownloadReport()} style={{ marginTop: '-4px' }}></img>
                                                            <span className="p-2 cursorPointer" onClick={() => this.DownloadReport()}>Download</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </>
                                    }
                                    <div>
                                        <iframe id="myFrame"  /* src={"data:text/html;base64," + this.state.report} */    srcDoc={this.state.HTMLreport}  style={{ width: "100%", height: "calc(100vh - 111px)" }} ></iframe>
                                    </div>
                                </div>
                                {/* </div> */}
                            </div></> :
                        <>{this.state.isMobile ?
                            <table className="dataTable border-top" width="100%">
                                <tbody>
                                    <tr className="">
                                        <td width="5%" className="border-right text-center">
                                            <i
                                                class="fa fa-arrow-left cursorPointer"
                                                onClick={this.AddCancel1}
                                            ></i>
                                        </td>
                                        <td width="95%">
                                        </td>
                                    </tr>
                                </tbody>
                            </table> :
                            <>
                                <table className="dataTable" width="100%">
                                    <tbody>
                                        <tr className="">
                                            <td width="5%" className="border-right text-center">
                                                <i
                                                    class="fa fa-arrow-left cursorPointer"
                                                    onClick={this.AddCancel1}
                                                ></i>
                                            </td>
                                            <td width="95%" className=""><>
                                            </>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </>}
                            <div className="row px-4 mt-5 pt-5 py-3">
                                <div className="col-12 mt-5 pb-2 text-center">
                                    <h6>No data to display</h6>
                                </div>
                            </div></>}
                </div>
            </>
        );
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        projectStatus: state.projectReducer.projectStatus || [],
    };
}

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(FinalReport))
);
